<script lang="ts" setup>
  import { computed, toRef } from 'vue';
  import { useField } from 'vee-validate';
  import Switch from './Switch.vue';
  import type { SwitchProps } from './Switch.types';

  type SwitchFieldProps = Omit<SwitchProps, 'modelValue'> & {
    name: string;
    rules?: (value: boolean) => string | boolean;
  };

  const props = defineProps<SwitchFieldProps>();

  const {
    value: fieldValue,
    errorMessage,
    handleChange,
    meta,
  } = useField<boolean>(() => props.name, props.rules, {
    label: toRef(props, 'label'),
  });

  const displayError = computed(() =>
    meta.touched ? errorMessage.value : undefined,
  );
</script>

<template>
  <Switch
    :id="id"
    :label="label"
    :helper-text="helperText"
    :name="name"
    :value="value"
    :disabled="disabled"
    :disabled-reason="disabledReason"
    :required="required"
    :model-value="fieldValue ?? false"
    :error="displayError"
    @update:model-value="handleChange"
  />
</template>
